import { Story, StoryCardOptions } from '../../../../../services';
import { CardProps } from '../../../../hooks';
import { optArrItem } from '../../../../utils';

interface CardGroupItemsArgs {
  editMode: boolean;
  postInStory?: Story;
  cardOptions?: StoryCardOptions;
}

interface LocaleGroupItemsArgs {
  editMode: boolean;
  postInStory?: Story;
  localeId?: number;
}

interface BackgroundColorGroupItemsArgs {
  editMode: boolean;
  postInStory?: Story;
  backgroundColor?: string;
}

export const getCardGroupItems = ({ editMode, postInStory, cardOptions }: CardGroupItemsArgs) => {
  const { settings } = { ...postInStory };

  const {
    allowComment,
    allowCardReaction,
    allowSharing,
    allowDisplayAuthor,
    shouldUpdatePostedTimeByComments: updateTimeByComments,
  } = { ...cardOptions };

  const {
    allowComments: storyAllowComments,
    allowCardReactions: storyAllowCardReactions,
    allowSharing: storyAllowSharing,
    shouldUpdatePostedTimeByComments: storyUpdateTimeByComments,
    showAllAuthors: storyShowAllAuthorsStory,
  } = { ...settings };

  return [
    ...optArrItem(Boolean(editMode ? allowComment : storyAllowComments), {
      id: CardProps.allowComments,
      value: CardProps.allowComments,
    }),
    ...optArrItem(Boolean(editMode ? allowCardReaction : storyAllowCardReactions), {
      id: CardProps.allowCardReactions,
      value: CardProps.allowCardReactions,
    }),
    ...optArrItem(Boolean(editMode ? allowSharing : storyAllowSharing), {
      id: CardProps.allowSharing,
      value: CardProps.allowSharing,
    }),
    ...optArrItem(Boolean(editMode ? updateTimeByComments : storyUpdateTimeByComments), {
      id: CardProps.shouldUpdatePostedTimeByComments,
      value: CardProps.shouldUpdatePostedTimeByComments,
    }),
    ...optArrItem(Boolean(editMode ? allowDisplayAuthor : storyShowAllAuthorsStory), {
      id: CardProps.showAllAuthors,
      value: CardProps.showAllAuthors,
    }),
  ];
};

export const getLocaleGroupItems = ({ editMode, postInStory, localeId }: LocaleGroupItemsArgs) => {
  if (!editMode) {
    return [{ value: postInStory?.localeId }];
  }
  return [{ value: localeId }];
};

export const getBackgroundColorGroupItems = ({
  editMode,
  postInStory,
  backgroundColor,
}: BackgroundColorGroupItemsArgs) => {
  if (!editMode) {
    return [{ value: postInStory?.settings.cardStyles.backgroundColor }];
  }
  return [{ value: backgroundColor }];
};
